// js/sections/HeaderSection.js
import Delegate from 'ftdomdelegate';
import { DesktopNavigation } from 'desktop-navigation';
import { MobileNavigation } from 'mobile-navigation';
import { SearchBar } from 'search-bar';
import { SecureStorage } from 'utils';

const normalizeWishlistHandle = (handle) => {
  const normalized = String(handle || '').trim().toLowerCase();
  return normalized !== '' && normalized !== 'null' && normalized !== 'undefined';
};

const getWishlistCount = () => {
  let storedHandles = [];
  const jsonData = SecureStorage.getJSON('shopify-wishlist', null);
  if (jsonData !== null) {
    storedHandles = jsonData.filter(normalizeWishlistHandle);
  } else {
    const stored = SecureStorage.getItem('shopify-wishlist');
    if (stored) {
      storedHandles = stored.split(',').filter(normalizeWishlistHandle);
    }
  }

  const customerHandles = Array.isArray(window.customer?.wishlist?.handles)
    ? window.customer.wishlist.handles.filter(normalizeWishlistHandle)
    : [];
  const customerCount = window.customer?.loggedIn ? customerHandles.length : 0;

  return Math.max(storedHandles.length, customerCount);
};

class HeaderSection extends HTMLElement {
  constructor() {
    super();
    
    this.delegateElement = new Delegate(this);
    this.settings = JSON.parse(this.getAttribute("data-settings")) || {};
  }
  connectedCallback() {
    let desktopNavigationElement = this.querySelector(this.settings["navigationLayout"] === "inline" ? ".nav-bar" : ".header__desktop-nav");
    if (desktopNavigationElement) {
      this.desktopNavigation = new DesktopNavigation(desktopNavigationElement, this.settings["navigationLayout"], this.settings["desktopOpenTrigger"]);
    }
    let mobileNavigationElement = this.querySelector(".header__mobile-nav");
    if (mobileNavigationElement) {
      this.mobileNavigation = new MobileNavigation(mobileNavigationElement);
    }
    this._setupCssVariables();
    this._attachListeners();
    this._updateWishlistCount();
  }
  disconnectedCallback() {
    if (this.desktopNavigation) {
      this.desktopNavigation.destroy();
    }
    if (this.mobileNavigation) {
      this.mobileNavigation.destroy();
    }
    window.removeEventListener("resize", this._setupCssVariablesListener);
  }
  onBlockSelect(event2) {
    if (this.desktopNavigation) {
      this.desktopNavigation.onBlockSelect(event2);
    }
  }
  onBlockDeselect(event2) {
    if (this.desktopNavigation) {
      this.desktopNavigation.onBlockDeselect(event2);
    }
  }
  _attachListeners() {
    this._setupCssVariablesListener = this._setupCssVariables.bind(this);
    window.addEventListener("resize", this._setupCssVariablesListener);
    this.delegateElement.on("click", '[data-action="toggle-search"]', this._toggleMobileSearch.bind(this));
  }
  /**
   * We have some positioning that is based on the CSS variables, so we must make sure to update them whenever
   * the section is reloaded into the editor
   */
  _setupCssVariables() {
    document.documentElement.style.setProperty("--header-height", this.parentNode.clientHeight + "px");
  }

  _updateWishlistCount() {
    const count = getWishlistCount();
    this.querySelectorAll('[data-wishlist-count-header], .header__wishlist-count')
      .forEach((element) => {
        if (element.textContent !== String(count)) {
          element.textContent = count;
        }
      });
  }
  /**
   * Toggle the mobile search
   */
  _toggleMobileSearch(event2) {
    const searchBar = this.querySelector("cos-search-bar");
    if (!searchBar) return;
    
    event2.preventDefault();
    searchBar.toggleMobileSearch();
  }
};

if (!window.customElements.get('cos-search-bar')) window.customElements.define('cos-search-bar', SearchBar);
if (!window.customElements.get("cos-header")) window.customElements.define("cos-header", HeaderSection);
